import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AuthContext = createContext();
const apiUrlLogin = process.env.REACT_APP_API_LOGIN;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const navigate = useNavigate();

  const login = async (nombre_usuario, password) => {
    try {
      const response = await axios.post(apiUrlLogin, { nombre_usuario, password });
      const { user, token } = response.data;
      console.log(user);

      if (user) {
        setUser(user);
        setAuthToken(token); 
        // Guardamos los datos completos en el localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify({ id: user.id, nombre_usuario: user.nombre_usuario, roles: user.roles }));
        navigate('/'); 
      }
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      alert('Usuario o contraseña incorrecta');
    }
  };

  const logout = () => {
    setUser(null);
    setAuthToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user'); // Eliminamos también el usuario al hacer logout
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ user, authToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}


export const useAuth = () => useContext(AuthContext);



